import {
  Box,
  Button,
  Container,
  Divider,
  Flex,
  HStack,
  Icon,
  Image,
  Text,
  VStack,
  Badge,
  useToast,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "../Context/CartContext";
import { MdSecurity, MdLocalShipping, MdLock } from "react-icons/md";
import { FiChevronRight, FiEdit2, FiCheckCircle, FiArrowLeft } from "react-icons/fi";
import { Link, Navigate } from "react-router-dom";
import { apiUrl } from "../ApiUrl/ApiUrl";

function PaymentPage() {
  const { cartData, globalAddress } = useContext(CartContext);
  const [totalDescPrice, setTotalDescPrice] = useState(0);
  const [totalOrigPrice, setTotalOrigPrice] = useState(0);
  const [gst, setGst] = useState(0);
  const [isProcessingHdfc, setIsProcessingHdfc] = useState(false);
  const [isProcessingRzp, setIsProcessingRzp] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("hdfc"); // "hdfc" or "razorpay"

  let sellingPrice = 0;
  let discount = 0;
  let totalAmount = 0;

  cartData.forEach(() => {
    sellingPrice = totalOrigPrice;
    discount = totalOrigPrice - totalDescPrice;
    totalAmount = sellingPrice - discount + gst;
  });

  const toast = useToast();

  function getprice() {
    const uid = localStorage.getItem("uid");

    fetch(`${apiUrl}/public/getAllCartById?uid=${uid}`)
      .then((res) => res.json())
      .then((res) => {
        const total = res.reduce(
          (sum, item) => sum + parseFloat(item.descprice || 0),
          0
        );
        const totalGst = res.reduce(
          (sum, item) => sum + parseFloat(item.gst || 0),
          0
        );

        setGst(totalGst);
        const originaltotal = res.reduce(
          (sum, item) =>
            sum + (item.quantity || 1) * parseFloat(item.originalprice || 0),
          0
        );
        setTotalDescPrice(total);
        setTotalOrigPrice(originaltotal);
      })
      .catch((error) => {
        console.error("Error fetching payment price:", error);
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getprice();
  }, []);

  const handleClickRazorpay = () => {
    setIsProcessingRzp(true);
    localStorage.setItem("apiUrl", apiUrl);
    window.location.href = "/payment.html";
  };

  const handelClick = () => {
    setIsProcessingHdfc(true);
    const uid = localStorage.getItem("uid");
    const email = localStorage.getItem("email");
    const name = localStorage.getItem("name");

    fetch(`${apiUrl}/public/process`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        order_id: localStorage.getItem("order_id"),
        amount: totalAmount,
        customer_id: uid,
        customer_email: email,
        customer_phone: "0000000",
        payment_page_client_id: "42962",
        action: "paymentPage",
        return_url: `${apiUrl}/public/payment/callback?redirect=${encodeURIComponent(
          window.location.origin
        )}`,
        description: "Complete your payment",
        first_name: name,
        last_name: "test",
        cid: uid,
      }),
    })
      .then(async (response) => {
        if (!response.ok) {
          const contentType = response.headers.get("content-type");
          if (
            response.status === 400 &&
            contentType &&
            contentType.includes("text/html")
          ) {
            alert(
              "You tried too many times. Please reload the page and try again."
            );
            return;
          }

          const errorText = await response.text();
          throw new Error(`Request failed: ${response.status} - ${errorText}`);
        }

        const data = await response.json();
        const paymentUrl = data.payment_links?.web;

        if (paymentUrl) {
          window.location.href = paymentUrl;
        } else {
          console.error("Payment URL not found in the response");
          alert("Something went wrong. Please try again later.");
        }
      })
      .catch((error) => {
        console.error("Error initiating payment:", error);
        alert("Duplicate order detected. Click Ok To Reload...");
        window.location.reload();
      })
      .finally(() => {
        setIsProcessingHdfc(false);
      });
  };

  if (cartData.length === 0) {
    return <Navigate to="/cart" />;
  }

  const userName =
    localStorage.getItem("name") ||
    localStorage.getItem("loginsetName") ||
    "Valued Customer";
  const userEmail =
    localStorage.getItem("email") || localStorage.getItem("username") || "";

  return (
    <Box bg="#F8FAFC" minH="90vh" py={{ base: 4, md: 8 }}>
      <Container maxW="1200px" px={{ base: 3, md: 6 }}>
        {/* Checkout Stepper Progress */}
        <Flex
          justify="space-between"
          align="center"
          mb={{ base: 5, md: 8 }}
          bg="white"
          p={{ base: 3, md: 4 }}
          rounded="xl"
          shadow="xs"
          border="1px solid"
          borderColor="gray.200"
          overflowX="auto"
        >
          <Link to="/cart">
            <HStack spacing={2} minW="fit-content" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Flex
                w="26px"
                h="26px"
                rounded="full"
                bg="green.500"
                color="white"
                align="center"
                justify="center"
                fontSize="xs"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="xs" fontWeight="semibold" color="gray.700" _hover={{ color: "#162237" }}>
                1. Cart
              </Text>
            </HStack>
          </Link>
          <Icon as={FiChevronRight} color="gray.400" />
          <Link to="/delivery">
            <HStack spacing={2} minW="fit-content" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Flex
                w="26px"
                h="26px"
                rounded="full"
                bg="green.500"
                color="white"
                align="center"
                justify="center"
                fontSize="xs"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="xs" fontWeight="semibold" color="gray.700" _hover={{ color: "#162237" }}>
                2. Address
              </Text>
            </HStack>
          </Link>
          <Icon as={FiChevronRight} color="gray.400" />
          <Link to="/summary">
            <HStack spacing={2} minW="fit-content" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Flex
                w="26px"
                h="26px"
                rounded="full"
                bg="green.500"
                color="white"
                align="center"
                justify="center"
                fontSize="xs"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="xs" fontWeight="semibold" color="gray.700" _hover={{ color: "#162237" }}>
                3. Summary
              </Text>
            </HStack>
          </Link>
          <Icon as={FiChevronRight} color="gray.400" />
          <HStack spacing={2} minW="fit-content">
            <Flex
              w="26px"
              h="26px"
              rounded="full"
              bg="#162237"
              color="#EAB308"
              align="center"
              justify="center"
              fontSize="xs"
              fontWeight="bold"
            >
              4
            </Flex>
            <Text fontSize="xs" fontWeight="bold" color="#162237">
              4. Payment
            </Text>
          </HStack>
        </Flex>

        {/* Main Grid */}
        <Flex
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 6, lg: 8 }}
          align="flex-start"
        >
          {/* Left Column: Completed Steps & Active Payment Options */}
          <VStack w={{ base: "100%", lg: "68%" }} spacing={4} align="stretch">
            {/* Step 1: Login Complete */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
            >
              <Flex justify="space-between" align="center">
                <HStack spacing={3}>
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="green.50"
                    color="green.600"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    ✓
                  </Flex>
                  <Box>
                    <Text
                      fontSize="xs"
                      color="gray.500"
                      fontWeight="bold"
                      textTransform="uppercase"
                      letterSpacing="wide"
                    >
                      Step 1: Account
                    </Text>
                    <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                      {userName}{" "}
                      {userEmail && (
                        <Text as="span" color="gray.500" fontWeight="normal">
                          ({userEmail})
                        </Text>
                      )}
                    </Text>
                  </Box>
                </HStack>
                <Badge colorScheme="green" fontSize="xs" px={2} py={0.5} rounded="md">
                  Active
                </Badge>
              </Flex>
            </Box>

            {/* Step 2: Delivery Address Complete */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
            >
              <Flex justify="space-between" align="flex-start" gap={3}>
                <HStack spacing={3} align="flex-start">
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="green.50"
                    color="green.600"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                    mt={0.5}
                  >
                    ✓
                  </Flex>
                  <Box>
                    <Text
                      fontSize="xs"
                      color="gray.500"
                      fontWeight="bold"
                      textTransform="uppercase"
                      letterSpacing="wide"
                    >
                      Step 2: Delivery Address
                    </Text>
                    <Text
                      fontSize="sm"
                      fontWeight="bold"
                      color="gray.900"
                      mt={0.5}
                    >
                      {globalAddress.Name || "Registered Customer"}
                    </Text>
                    <Text
                      fontSize="xs"
                      color="gray.600"
                      mt={0.5}
                      maxW="450px"
                      lineHeight="tall"
                    >
                      {globalAddress.Address
                        ? `${globalAddress.Address}, ${globalAddress.City} - ${globalAddress.Pincode}`
                        : "Default Delivery Address Selected"}
                    </Text>
                  </Box>
                </HStack>

                <Link to="/delivery">
                  <Button
                    size="sm"
                    variant="outline"
                    borderColor="#162237"
                    color="#162237"
                    _hover={{ bg: "#162237", color: "white" }}
                    leftIcon={<FiEdit2 />}
                    rounded="lg"
                    fontWeight="bold"
                    px={3}
                  >
                    Change Address
                  </Button>
                </Link>
              </Flex>
            </Box>

            {/* Step 3: Order Summary Complete */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
            >
              <Flex justify="space-between" align="center">
                <HStack spacing={3}>
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="green.50"
                    color="green.600"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    ✓
                  </Flex>
                  <Box>
                    <Text
                      fontSize="xs"
                      color="gray.500"
                      fontWeight="bold"
                      textTransform="uppercase"
                      letterSpacing="wide"
                    >
                      Step 3: Order Summary
                    </Text>
                    <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                      {cartData.length} {cartData.length === 1 ? "Item" : "Items"} in Cart
                    </Text>
                  </Box>
                </HStack>

                <Link to="/summary">
                  <Button
                    size="sm"
                    variant="outline"
                    borderColor="#162237"
                    color="#162237"
                    _hover={{ bg: "#162237", color: "white" }}
                    leftIcon={<FiEdit2 />}
                    rounded="lg"
                    fontWeight="bold"
                    px={3}
                  >
                    Review Order
                  </Button>
                </Link>
              </Flex>
            </Box>

            {/* Quick Navigation Back Bar */}
            <HStack justify="space-between" align="center" px={1} py={1}>
              <Link to="/summary">
                <Button
                  size="sm"
                  variant="ghost"
                  color="#162237"
                  _hover={{ bg: "gray.100" }}
                  leftIcon={<FiArrowLeft />}
                  fontWeight="bold"
                >
                  ← Back to Order Summary
                </Button>
              </Link>
              <Link to="/delivery">
                <Text fontSize="xs" color="blue.600" textDecoration="underline" cursor="pointer">
                  Need to change address? Click here
                </Text>
              </Link>
            </HStack>

            {/* Step 4: Active Payment Gateway Options */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="#162237"
              shadow="sm"
              overflow="hidden"
            >
              {/* Active Step Bar */}
              <Flex
                bg="#162237"
                color="white"
                px={{ base: 4, md: 5 }}
                py={3.5}
                align="center"
                justify="space-between"
              >
                <HStack spacing={3}>
                  <Flex
                    w="26px"
                    h="26px"
                    rounded="full"
                    bg="#EAB308"
                    color="#0F172A"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    4
                  </Flex>
                  <Text fontSize="sm" fontWeight="bold" letterSpacing="wide">
                    SELECT PAYMENT GATEWAY
                  </Text>
                </HStack>
                <HStack spacing={1}>
                  <Icon as={MdLock} color="#EAB308" />
                  <Text fontSize="xs" color="gray.300">256-Bit SSL Encrypted</Text>
                </HStack>
              </Flex>

              {/* Payment Methods Grid */}
              <VStack p={{ base: 4, md: 6 }} spacing={4} align="stretch">
                {/* Method 1: HDFC Bank Gateway */}
                <Box
                  p={{ base: 4, md: 5 }}
                  rounded="xl"
                  border="2px solid"
                  borderColor={selectedMethod === "hdfc" ? "#162237" : "gray.200"}
                  bg={selectedMethod === "hdfc" ? "blue.50" : "white"}
                  cursor="pointer"
                  onClick={() => setSelectedMethod("hdfc")}
                  transition="all 0.2s ease"
                  _hover={{ borderColor: "#162237", shadow: "sm" }}
                >
                  <Flex
                    direction={{ base: "column", sm: "row" }}
                    justify="space-between"
                    align={{ base: "flex-start", sm: "center" }}
                    gap={4}
                  >
                    <HStack spacing={4} align="center">
                      <Box
                        w="20px"
                        h="20px"
                        rounded="full"
                        border="2px solid"
                        borderColor={selectedMethod === "hdfc" ? "#162237" : "gray.400"}
                        p="2px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        {selectedMethod === "hdfc" && (
                          <Box w="10px" h="10px" rounded="full" bg="#162237" />
                        )}
                      </Box>

                      <Box
                        w="80px"
                        h="42px"
                        bg="white"
                        rounded="md"
                        border="1px solid"
                        borderColor="gray.200"
                        p={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Image
                          src="/hdfc.png"
                          alt="HDFC Bank"
                          maxH="32px"
                          fallbackSrc="https://upload.wikimedia.org/wikipedia/commons/2/28/HDFC_Bank_Logo.svg"
                        />
                      </Box>

                      <Box>
                        <HStack spacing={2}>
                          <Text fontSize="sm" fontWeight="bold" color="gray.900">
                            HDFC SmartHub Payment Gateway
                          </Text>
                          <Badge colorScheme="blue" fontSize="10px">
                            Recommended
                          </Badge>
                        </HStack>
                        <Text fontSize="xs" color="gray.600" mt={0.5}>
                          Credit & Debit Cards, NetBanking, UPI, and Digital Wallets
                        </Text>
                      </Box>
                    </HStack>

                    <Button
                      size="md"
                      bg="#162237"
                      color="white"
                      _hover={{ bg: "#0F172A", shadow: "md" }}
                      _active={{ bg: "#0B132B" }}
                      px={6}
                      fontWeight="bold"
                      fontSize="xs"
                      rounded="lg"
                      isLoading={isProcessingHdfc}
                      loadingText="Connecting..."
                      onClick={(e) => {
                        e.stopPropagation();
                        handelClick();
                      }}
                      alignSelf={{ base: "stretch", sm: "auto" }}
                    >
                      PAY HDFC ₹{totalAmount}
                    </Button>
                  </Flex>
                </Box>

                {/* Method 2: Razorpay Gateway */}
                <Box
                  p={{ base: 4, md: 5 }}
                  rounded="xl"
                  border="2px solid"
                  borderColor={selectedMethod === "razorpay" ? "#162237" : "gray.200"}
                  bg={selectedMethod === "razorpay" ? "blue.50" : "white"}
                  cursor="pointer"
                  onClick={() => setSelectedMethod("razorpay")}
                  transition="all 0.2s ease"
                  _hover={{ borderColor: "#162237", shadow: "sm" }}
                >
                  <Flex
                    direction={{ base: "column", sm: "row" }}
                    justify="space-between"
                    align={{ base: "flex-start", sm: "center" }}
                    gap={4}
                  >
                    <HStack spacing={4} align="center">
                      <Box
                        w="20px"
                        h="20px"
                        rounded="full"
                        border="2px solid"
                        borderColor={selectedMethod === "razorpay" ? "#162237" : "gray.400"}
                        p="2px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        {selectedMethod === "razorpay" && (
                          <Box w="10px" h="10px" rounded="full" bg="#162237" />
                        )}
                      </Box>

                      <Box
                        w="80px"
                        h="42px"
                        bg="white"
                        rounded="md"
                        border="1px solid"
                        borderColor="gray.200"
                        p={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Image
                          src="/razorpay.png"
                          alt="Razorpay"
                          maxH="28px"
                          fallbackSrc="https://upload.wikimedia.org/wikipedia/commons/8/89/Razorpay_logo.svg"
                        />
                      </Box>

                      <Box>
                        <HStack spacing={2}>
                          <Text fontSize="sm" fontWeight="bold" color="gray.900">
                            Razorpay Secure Checkout
                          </Text>
                          <Badge colorScheme="purple" fontSize="10px">
                            Instant UPI
                          </Badge>
                        </HStack>
                        <Text fontSize="xs" color="gray.600" mt={0.5}>
                          Google Pay, PhonePe, Paytm, QR Code, Cards & NetBanking
                        </Text>
                      </Box>
                    </HStack>

                    <Button
                      size="md"
                      bg="#fb641b"
                      color="white"
                      _hover={{ bg: "#e65c1b", shadow: "md" }}
                      _active={{ bg: "#cf5317" }}
                      px={6}
                      fontWeight="bold"
                      fontSize="xs"
                      rounded="lg"
                      isLoading={isProcessingRzp}
                      loadingText="Redirecting..."
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClickRazorpay();
                      }}
                      alignSelf={{ base: "stretch", sm: "auto" }}
                    >
                      PAY RAZORPAY ₹{totalAmount}
                    </Button>
                  </Flex>
                </Box>

                {/* Gateway Trust Summary */}
                <Box
                  p={4}
                  bg="gray.50"
                  rounded="lg"
                  border="1px solid"
                  borderColor="gray.200"
                  mt={2}
                >
                  <HStack spacing={3} align="flex-start">
                    <Icon as={MdSecurity} color="green.600" boxSize={5} mt={0.5} />
                    <Box>
                      <Text fontSize="xs" fontWeight="bold" color="gray.800">
                        Zero Payment Surcharge & Fraud Protection
                      </Text>
                      <Text fontSize="xs" color="gray.600" mt={0.5}>
                        We do not store your card details or CVV. All transactions are securely routed through PCI-DSS Level 1 certified banking partners.
                      </Text>
                    </Box>
                  </HStack>
                </Box>
              </VStack>
            </Box>
          </VStack>

          {/* Right Column: Price Details & Trust */}
          <Box w={{ base: "100%", lg: "32%" }} position={{ lg: "sticky" }} top="24px">
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              shadow="xs"
              p={{ base: 4, md: 6 }}
            >
              <Text
                fontSize="xs"
                fontWeight="bold"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="wider"
                mb={4}
              >
                Price Details ({cartData.length} {cartData.length === 1 ? "Item" : "Items"})
              </Text>

              <VStack spacing={3} align="stretch" fontSize="sm">
                <Flex justify="space-between">
                  <Text color="gray.600">Total MRP</Text>
                  <Text fontWeight="medium" color="gray.800">
                    ₹{sellingPrice}
                  </Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Catalogue Discount</Text>
                  <Text fontWeight="medium" color="green.600">
                    - ₹{discount}
                  </Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Price After Discount</Text>
                  <Text fontWeight="medium" color="gray.800">
                    ₹{sellingPrice - discount}
                  </Text>
                </Flex>

                <Flex justify="space-between" align="center">
                  <Text color="gray.600">Delivery Charges</Text>
                  <HStack spacing={1}>
                    <Text as="del" fontSize="xs" color="gray.400">
                      ₹99
                    </Text>
                    <Badge colorScheme="green" fontSize="xs">
                      FREE
                    </Badge>
                  </HStack>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Applicable GST</Text>
                  <Text fontWeight="medium" color="gray.800">
                    {gst > 0 ? `₹${gst}` : "₹0"}
                  </Text>
                </Flex>

                <Divider my={2} />

                <Flex justify="space-between" align="baseline">
                  <Text fontSize="md" fontWeight="bold" color="gray.900">
                    Total Payable
                  </Text>
                  <Text fontSize="xl" fontWeight="extrabold" color="#162237">
                    ₹{totalAmount}
                  </Text>
                </Flex>
              </VStack>

              {discount > 0 && (
                <Box
                  mt={4}
                  p={2.5}
                  bg="green.50"
                  border="1px solid"
                  borderColor="green.200"
                  rounded="lg"
                  textAlign="center"
                >
                  <Text fontSize="xs" fontWeight="semibold" color="green.700">
                    🎉 You are saving ₹{discount} on this order!
                  </Text>
                </Box>
              )}

              {/* GST Statutory Information Note */}
              <Box
                mt={4}
                p={3}
                bg="gray.50"
                rounded="lg"
                border="1px dashed"
                borderColor="gray.300"
              >
                <Text fontSize="11px" fontWeight="semibold" color="gray.700" mb={1}>
                  Statutory GST Breakdown:
                </Text>
                <Text fontSize="10px" color="gray.600" lineHeight="tall">
                  • 📚 Law Books & Acts: 0% GST (Exempt)
                  <br />
                  • 💻 Legal Softwares & Subscriptions: 18% GST
                  <br />
                  • 👕 Advocate Apparel: 5% (≤₹1000) / 12% (&gt;₹1000)
                </Text>
              </Box>

              {/* Trust Badges */}
              <VStack
                spacing={2}
                align="stretch"
                mt={5}
                pt={4}
                borderTop="1px solid"
                borderColor="gray.100"
              >
                <HStack spacing={2.5} color="gray.600" fontSize="xs">
                  <Icon as={MdSecurity} color="#162237" boxSize={4} />
                  <Text>100% Safe & Secure 256-bit Encrypted Payments</Text>
                </HStack>
                <HStack spacing={2.5} color="gray.600" fontSize="xs">
                  <Icon as={MdLocalShipping} color="#162237" boxSize={4} />
                  <Text>Reliable Express Courier Dispatch Across India</Text>
                </HStack>
              </VStack>
            </Box>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}

export default PaymentPage;
